<!--
  REV-21373 — Detailansicht eines Eintrags (ADR-0019 E7/E9).

  ⚠️ Aufbau nach dem AWF-Prototyp: Kopf (Titel · Beschreibung · Zitat), Eigenschaften-Tabelle,
  `Verlauf (n)` als Chat-Blasen, darunter das Antwortfeld — und `Bearbeiten`/`Loeschen` in der
  FUSSZEILE, `Zurueck` oben rechts. Die erste Fassung hatte die Aktionen oben und den Verlauf als
  flache Liste; beides sieht der Prototyp anders.

  SELEKTOR-CONTRACT — die Tests haengen HIER dran, nie an Klassen, Farben oder uebersetztem Text:

    [data-testid="note-detail"]              Wurzel; [data-kind], [data-done]
    [data-testid="note-detail-back"]         „Zurueck" (oben rechts)
    [data-testid="note-detail-text"]         der Titel im Kopf
    [data-testid="note-detail-anchor"]       das Zitat
    [data-testid="note-detail-fact"]         Zeile der Eigenschaften-Tabelle; [data-fact-key]
    [data-testid="note-detail-fact-value"]   deren Wert
    [data-testid="note-detail-status"]       die Status-Pille; [data-status]
    [data-testid="note-detail-overdue"]      der „ueberfaellig"-Zusatz an der Faelligkeit
    [data-testid="note-detail-account"]      das anklickbare Konto
    [data-testid="note-detail-history"]      „Verlauf (n)" — NUR am Kommentar
    [data-testid="note-detail-reply"]        eine Antwort; [data-reply-id], [data-own]
    [data-testid="note-detail-replies-empty"] „Noch keine Antworten." — dito
    [data-testid="note-detail-reply-form"]   das Antwortfeld — an der PENDENZ ABWESEND
    [data-testid="note-detail-reply-send"]   dessen „Senden"
    [data-testid="note-detail-done"]         „Erledigt"/„Wieder oeffnen" — NUR an der Pendenz; [data-done]
    [data-testid="note-detail-edit"]         „Bearbeiten" (Fusszeile)
    [data-testid="note-detail-delete"]       „Loeschen" (Fusszeile)
    [data-testid="note-detail-delete-confirm"]  Rueckfrage
    [data-testid="note-detail-delete-yes"]   deren Bestaetigung
    [data-testid="note-detail-delete-no"]    deren Abbruch
    [data-testid="note-detail-form"]         Bearbeiten-Formular
    [data-testid="note-detail-field"]        ein Feld darin; [data-field]
    [data-testid="note-detail-tag"]          Marke im Formular; [data-tag], [aria-pressed]
    [data-testid="note-detail-save"]         „Speichern"
    [data-testid="note-detail-cancel"]       „Abbrechen"
    [data-testid="note-detail-loading"]      laedt
    [data-testid="note-detail-missing"]      gibt es nicht
    [data-testid="note-detail-error"]        liess sich nicht laden
    [data-testid="note-detail-retry"]        erneut versuchen

  ⚠️ Praezedenz: loading > missing > error > filled. „Gibt es nicht" und „liess sich nicht laden"
  sind VERSCHIEDENE Saetze (AC9).
-->
<section class="note-dt" data-testid="note-detail" [attr.data-kind]="note?.kind" [attr.data-done]="isDone ? '' : null">
    <!-- Top right, the same back control as the account page. -->
    <div class="note-dt__topbar" *ngIf="showBack">
        <ham-button
            data-testid="note-detail-back"
            variant="white"
            icon="assets/hamIcons/x.svg"
            (buttonClick)="backRequested.emit()"
        >
            {{ 'aumico_abcp_notes_detail_back' | i18next }}
        </ham-button>
    </div>

    <div class="note-dt__state" data-testid="note-detail-loading" *ngIf="loading">
        <div class="note-dt__skeleton"></div>
        <div class="note-dt__skeleton"></div>
    </div>

    <ng-container *ngIf="!loading">
        <p class="note-dt__state" data-testid="note-detail-missing" *ngIf="missing">
            {{ 'aumico_abcp_notes_detail_missing' | i18next }}
        </p>

        <div class="note-dt__state note-dt__state--error" data-testid="note-detail-error" *ngIf="!missing && error">
            <p>{{ 'aumico_abcp_notes_detail_error' | i18next }}</p>
            <ham-button data-testid="note-detail-retry" variant="white" size="sm" (buttonClick)="retryRequested.emit()">
                {{ 'aumico_abcp_notes_retry' | i18next }}
            </ham-button>
        </div>

        <!--
            Der Inhalt sitzt in EINER Karte, wie im Prototyp (28/32 Polster, 12 Radius). Vorher
            schwebte alles frei auf der Seite, was der Grund ist, warum die Ansicht „ganz anders"
            aussah als die Vorlage.
        -->
        <div class="note-dt__panel" *ngIf="!missing && !error && note">
            <!-- ── Kopf ────────────────────────────────────────────────────────────────────── -->
            <header class="note-dt__head" *ngIf="!editing">
                <h1 class="note-dt__title" data-testid="note-detail-text">{{ note.text }}</h1>

                <!-- ⚠️ Kein Wert ⇒ GAR NICHTS, wie bei den übrigen Feldern (AC3). Ein leerer Absatz
                     unter dem Titel sieht aus wie ein Ladefehler. -->
                <p class="note-dt__description" data-testid="note-detail-description" *ngIf="note.description">
                    {{ note.description }}
                </p>

                <blockquote
                    class="note-dt__anchor"
                    data-testid="note-detail-anchor"
                    *ngIf="note.anchor"
                    [attr.data-linked]="note.anchor.blockId || note.anchor.documentId ? '' : null"
                    [attr.data-document-id]="note.anchor.documentId || null"
                    [attr.data-page]="note.anchor.page ?? null"
                    (click)="onAnchorClick()"
                >
                    <ng-container *ngIf="note.anchor.snippet; else areaAnchor">{{ note.anchor.snippet }}</ng-container>
                    <!-- REV-21369 — Flächen-Markierung im Beleg: kein Text, also die Seite. -->
                    <ng-template #areaAnchor>{{
                        'aumico_abcp_notes_anchor_area' | i18next: { page: note.anchor.page }
                    }}</ng-template>
                </blockquote>
            </header>

            <!-- ── Eigenschaften ───────────────────────────────────────────────────────────── -->
            <dl class="note-dt__facts" *ngIf="!editing">
                <ng-container *ngFor="let fact of note.facts; trackBy: trackByKey">
                    <!-- ⚠️ Kein Wert ⇒ die Zeile erscheint GAR NICHT (AC3). -->
                    <div
                        class="note-dt__fact"
                        data-testid="note-detail-fact"
                        *ngIf="fact.value"
                        [attr.data-fact-key]="fact.key"
                    >
                        <dt class="note-dt__fact-label">{{ fact.label }}</dt>
                        <dd class="note-dt__fact-value" data-testid="note-detail-fact-value">
                            <!-- Status als Pille: gruen erledigt, bernstein offen. -->
                            <span
                                class="note-dt__status"
                                data-testid="note-detail-status"
                                *ngIf="fact.key === 'status'"
                                [attr.data-status]="isDone ? 'done' : 'open'"
                            >
                                {{ fact.value }}
                            </span>

                            <!-- Das Konto fuehrt zum Konto (AC4). -->
                            <button
                                type="button"
                                class="note-dt__account"
                                data-testid="note-detail-account"
                                *ngIf="fact.key === 'account' && note.accountId"
                                (click)="onAccountOpen()"
                            >
                                {{ fact.value }}
                            </button>

                            <!-- Der Verfasser mit Initialen-Avatar. -->
                            <span class="note-dt__author" *ngIf="fact.key === 'author'">
                                <span class="note-dt__avatar" aria-hidden="true">{{ initialsOf(fact.value) }}</span>
                                {{ fact.value }}
                            </span>

                            <!-- Faellig: ueberfaellig wird eingefaerbt UND benannt. -->
                            <span *ngIf="fact.key === 'due'" [class.note-dt__due--overdue]="overdue">
                                {{ fact.value }}
                                <span data-testid="note-detail-overdue" *ngIf="overdue">
                                    · {{ 'aumico_abcp_notes_overdue' | i18next }}
                                </span>
                            </span>

                            <span *ngIf="isPlainFact(fact.key)">{{ fact.value }}</span>
                        </dd>
                    </div>
                </ng-container>
            </dl>

            <!-- ── Bearbeiten ──────────────────────────────────────────────────────────────── -->
            <!--
                Das Formular hat den AUFBAU DER SEITE, nicht den einer Eingabemaske: Titel gross
                oben, Erläuterung darunter, und dann dieselbe Eigenschaften-Tabelle wie beim Lesen,
                nur mit Eingabefeldern in den Zeilen, die sich ändern lassen. Genau so zeigt es
                der Prototyp — und es hat den praktischen Vorteil, dass beim Umschalten nichts
                springt: die Zeilen stehen vorher und nachher an derselben Stelle.

                ⚠️ `Status` und `Erstellt` sind auch hier LESBAR, aber nicht änderbar. Sie
                wegzulassen hätte die Tabelle beim Bearbeiten kürzer gemacht und den Eindruck
                erweckt, sie seien verschwunden.
            -->
            <form class="note-dt__form" data-testid="note-detail-form" *ngIf="editing">
                <label class="note-dt__field note-dt__field--title" data-testid="note-detail-field" data-field="text">
                    <span class="note-dt__sr-only">{{ 'aumico_abcp_notes_detail_field_text' | i18next }}</span>
                    <input
                        hamInput
                        type="text"
                        class="note-dt__title-input"
                        [hideRemoveXButton]="true"
                        [(ngModel)]="editText"
                        name="text"
                        [attr.placeholder]="'aumico_abcp_notes_detail_field_text' | i18next"
                    />
                </label>

                <label
                    class="note-dt__field note-dt__field--description"
                    data-testid="note-detail-field"
                    data-field="description"
                    *ngIf="mayEditField('description')"
                >
                    <span class="note-dt__sr-only">{{ 'aumico_abcp_notes_detail_field_description' | i18next }}</span>
                    <textarea
                        hamInput
                        rows="3"
                        class="note-dt__desc-input"
                        [hideRemoveXButton]="true"
                        [(ngModel)]="editDescription"
                        name="description"
                        [attr.placeholder]="'aumico_abcp_notes_detail_field_description' | i18next"
                    ></textarea>
                </label>

                <dl class="note-dt__facts note-dt__facts--editing">
                    <!-- Status: lesbar, nicht änderbar — abgehakt wird mit dem Knopf im Fuss. -->
                    <div class="note-dt__fact" data-testid="note-detail-field" data-field="status" *ngIf="isTodo">
                        <dt class="note-dt__fact-label">
                            {{ 'aumico_abcp_notes_detail_field_status' | i18next }}
                        </dt>
                        <dd class="note-dt__fact-value">
                            <span class="note-dt__status" [attr.data-status]="isDone ? 'done' : 'open'">
                                {{
                                    (isDone ? 'aumico_abcp_notes_filter_done' : 'aumico_abcp_notes_filter_open')
                                        | i18next
                                }}
                            </span>
                        </dd>
                    </div>

                    <div class="note-dt__fact" data-testid="note-detail-field" data-field="tags">
                        <dt class="note-dt__fact-label">{{ 'aumico_abcp_notes_detail_field_tags' | i18next }}</dt>
                        <dd class="note-dt__fact-value">
                            <!--
                                ⚠️ Die Pendenz hat GENAU EINE Zielgruppe, der Kommentar kann mehrere
                                Klassifizierungen tragen. Beide als Pillen: bei der Pendenz waehlt ein
                                Klick die eine (keine abwaehlbar), beim Kommentar schaltet er um.
                            -->
                            <div class="note-dt__tags" *ngIf="isTodo">
                                <ham-filter-pill
                                    data-testid="note-detail-tag"
                                    *ngFor="let tag of availableTags"
                                    [attr.data-tag]="tag"
                                    [label]="'aumico_abcp_notes_audience_' + tag | lowercase | i18next"
                                    [active]="soleTag === tag"
                                    (pillClick)="setSoleTag(tag)"
                                ></ham-filter-pill>
                            </div>

                            <div class="note-dt__tags" *ngIf="!isTodo">
                                <ham-filter-pill
                                    data-testid="note-detail-tag"
                                    *ngFor="let tag of availableTags"
                                    [attr.data-tag]="tag"
                                    [label]="'aumico_abcp_notes_tag_' + tag | lowercase | i18next"
                                    [active]="isEditTagOn(tag)"
                                    (pillClick)="toggleEditTag(tag)"
                                ></ham-filter-pill>
                            </div>
                        </dd>
                    </div>

                    <div
                        class="note-dt__fact"
                        data-testid="note-detail-field"
                        data-field="account"
                        *ngIf="mayEditField('account')"
                    >
                        <dt class="note-dt__fact-label">{{ 'aumico_abcp_notes_col_account' | i18next }}</dt>
                        <dd class="note-dt__fact-value">
                            <!-- Searchable by number and name; the clear button means "kein Konto". -->
                            <input
                                hamSimpleDropDown
                                [restoreSelectionOnBlur]="true"
                                name="account"
                                [options]="accountOptions"
                                [optionKeys]="['label']"
                                returnKey="accountId"
                                [(ngModel)]="editAccountId"
                            />
                        </dd>
                    </div>

                    <!-- Erstellt: lesbar, nie änderbar — ein Erstelldatum, das man setzen kann, ist keines. -->
                    <div class="note-dt__fact" data-testid="note-detail-field" data-field="created" *ngIf="createdLabel">
                        <dt class="note-dt__fact-label">{{ 'aumico_abcp_notes_col_created' | i18next }}</dt>
                        <dd class="note-dt__fact-value">{{ createdLabel }}</dd>
                    </div>

                    <!-- ⚠️ Faelligkeit und Zuweisung erscheinen nur, wenn der Eintrag sie freigibt (AC6). -->
                    <div
                        class="note-dt__fact"
                        data-testid="note-detail-field"
                        data-field="due"
                        *ngIf="mayEditField('due')"
                    >
                        <dt class="note-dt__fact-label">{{ 'aumico_abcp_notes_detail_field_due' | i18next }}</dt>
                        <dd class="note-dt__fact-value">
                            <!-- ⚠️ Ein Datumswaehler, kein freies Textfeld: der Server nimmt nur ISO-8601. -->
                            <app-date-picker-flyout name="due" [(ngModel)]="editDue"></app-date-picker-flyout>
                        </dd>
                    </div>

                    <!-- Zuweisen ist ein FELD im Formular, kein eigener Knopf (ADR-0019 E9). -->
                    <div
                        class="note-dt__fact"
                        data-testid="note-detail-field"
                        data-field="assignee"
                        *ngIf="mayEditField('assignee')"
                    >
                        <dt class="note-dt__fact-label">
                            {{ 'aumico_abcp_notes_detail_field_assignee' | i18next }}
                        </dt>
                        <dd class="note-dt__fact-value">
                            <input
                                hamSimpleDropDown
                                [restoreSelectionOnBlur]="true"
                                name="assignee"
                                [options]="assignees"
                                [optionKeys]="['displayName']"
                                returnKey="userId"
                                [(ngModel)]="editAssigneeId"
                            />
                        </dd>
                    </div>
                </dl>

                <!--
                    Submits through `buttonClick`, not `ngSubmit`: ham-button disables itself inside its
                    own click, which can cancel the native submit. Enter in a field still clicks this
                    default button, so it saves too.
                -->
                <div class="note-dt__form-actions">
                    <ham-button
                        data-testid="note-detail-save"
                        type="submit"
                        variant="primary"
                        [disabled]="!canSubmitEdit"
                        (buttonClick)="onEditSubmit()"
                    >
                        {{ 'aumico_abcp_notes_save' | i18next }}
                    </ham-button>
                    <ham-button data-testid="note-detail-cancel" variant="white" (buttonClick)="editCancel.emit()">
                        {{ 'aumico_abcp_notes_cancel' | i18next }}
                    </ham-button>
                </div>
            </form>

            <!--
                Verlauf — NUR am Kommentar.

                ⚠️ An der Pendenz stand hier „Verlauf (0)" und darunter „Noch keine Antworten." —
                zwei Sätze über etwas, das es an einer Pendenz gar nicht gibt: man antwortet auf
                einen Kommentar, eine Pendenz hakt man ab. Die leere Überschrift las sich wie ein
                Fehler („warum antwortet niemand?"), wo in Wahrheit nichts fehlte.

                ⚠️ Das weicht von AC5 ab, der den Verlauf an der Pendenz SICHTBAR und nur das
                Antwortfeld abwesend verlangte. Bewusst, auf Ansage beim Durchsehen — der Contract
                hält die neue Zusage fest.
            -->
            <section class="note-dt__history" *ngIf="note.kind !== 'TODO'">
                <h2 class="note-dt__history-title" data-testid="note-detail-history">
                    {{ 'aumico_abcp_notes_detail_history' | i18next }} ({{ note.replies.length }})
                </h2>

                <p class="note-dt__replies-empty" data-testid="note-detail-replies-empty" *ngIf="note.replies.length === 0">
                    {{ 'aumico_abcp_notes_detail_no_replies' | i18next }}
                </p>

                <!-- Chat-Blasen: eigene Beitraege rechts, fremde links. -->
                <div class="note-dt__replies" *ngIf="note.replies.length > 0">
                    <div
                        class="note-dt__reply"
                        data-testid="note-detail-reply"
                        *ngFor="let reply of note.replies; trackBy: trackById"
                        [attr.data-reply-id]="reply.id"
                        [attr.data-own]="isOwnReply(reply) ? '' : null"
                    >
                        <span class="note-dt__avatar" aria-hidden="true">{{ initialsOf(reply.author.name) }}</span>
                        <div class="note-dt__bubble">
                            <div class="note-dt__bubble-head">
                                <span class="note-dt__reply-author">
                                    {{ reply.author.name || ('aumico_abcp_notes_author_unknown' | i18next) }}
                                </span>
                                <span class="note-dt__reply-time">{{ reply.timeLabel }}</span>
                            </div>
                            <p class="note-dt__reply-text">{{ reply.text }}</p>
                        </div>
                    </div>
                </div>

                <!-- ⚠️ An der Pendenz ist der Verlauf sichtbar, das Antwortfeld aber ABWESEND (AC5). -->
                <!-- Submits through `buttonClick`, like the edit form. -->
                <form class="note-dt__reply-form" data-testid="note-detail-reply-form" *ngIf="mayReply">
                    <input
                        type="text"
                        [(ngModel)]="replyDraft"
                        name="reply"
                        [attr.placeholder]="'aumico_abcp_notes_reply_placeholder' | i18next"
                    />
                    <ham-button
                        data-testid="note-detail-reply-send"
                        type="submit"
                        variant="primary"
                        size="sm"
                        [disabled]="!canSubmitReply"
                        (buttonClick)="onReplySubmit()"
                    >
                        {{ 'aumico_abcp_notes_send' | i18next }}
                    </ham-button>
                </form>
            </section>

            <!-- ── Fusszeile ───────────────────────────────────────────────────────────────── -->
            <footer class="note-dt__footer" *ngIf="!editing">
                <!--
                    ⚠️ „Erledigt"/„Wieder öffnen" NUR an der Pendenz, und als eigener Knopf statt
                    als Feld im Bearbeiten-Formular: abhaken ist die häufigste Handlung an einer
                    Pendenz und darf nicht hinter „Bearbeiten" liegen. Die Beschriftung sagt, was
                    der Klick TUT, nicht wie der Zustand heißt.
                -->
                <!-- ham-button cannot pass `aria-pressed` on, so the state rides on `data-done`. -->
                <ham-button
                    data-testid="note-detail-done"
                    *ngIf="note.kind === 'TODO'"
                    variant="green"
                    [outline]="true"
                    [attr.data-done]="isDone ? '' : null"
                    (buttonClick)="doneToggle.emit(note.id)"
                >
                    {{ (isDone ? 'aumico_abcp_notes_reopen' : 'aumico_abcp_notes_done') | i18next }}
                </ham-button>
                <ham-button
                    data-testid="note-detail-edit"
                    *ngIf="note.canEdit"
                    variant="white"
                    (buttonClick)="editStart.emit(note.id)"
                >
                    {{ 'aumico_abcp_notes_edit' | i18next }}
                </ham-button>
                <ham-button
                    data-testid="note-detail-delete"
                    *ngIf="note.canDelete && !confirmDelete"
                    variant="red"
                    [outline]="true"
                    (buttonClick)="askDelete()"
                >
                    {{ 'aumico_abcp_notes_delete' | i18next }}
                </ham-button>

                <div class="note-dt__confirm" data-testid="note-detail-delete-confirm" *ngIf="confirmDelete">
                    <span>{{ 'aumico_abcp_notes_delete_confirm' | i18next }}</span>
                    <ham-button
                        data-testid="note-detail-delete-yes"
                        variant="red"
                        [outline]="true"
                        (buttonClick)="doDelete()"
                    >
                        {{ 'aumico_abcp_notes_delete' | i18next }}
                    </ham-button>
                    <ham-button data-testid="note-detail-delete-no" variant="white" (buttonClick)="cancelDelete()">
                        {{ 'aumico_abcp_notes_cancel' | i18next }}
                    </ham-button>
                </div>
            </footer>
        </div>
    </ng-container>
</section>
